module.exports = __webpack_public_path__ + "static/media/clyh.47d573113d0711308293f774014c160f.svg";